import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

import { BRANCHES } from '@constants/routes';

const BranchReportPage = lazy(
  () => import('@features/branch-reports/pages/reports/BranchReportPage')
);

export const BranchReportRoutes: RouteObject[] = [
  {
    path: BRANCHES.REPORTS,
    element: <BranchReportPage />
  }
];

export default BranchReportRoutes;
